<script>
    import { onMount } from 'svelte';
    import { Child } from 'pym.js';
    import Graphic from './Graphic.svelte';
    import pkg from '../package.json';
    import data from './data/data.json';

    let pymChild = $state();
    let width = $state(600);
    let height = $state(0);
    let containerElement = $state();

    function handlePymResize(newWidth) {
      width = newWidth;
    }

    // Send an updated height to the parent whenever the graphic resizes.
    $effect(() => {
      if (pymChild && height > 0) {
        pymChild.sendHeight();
      }
    });

    onMount(() => {
      pymChild = new Child({
        renderCallback: handlePymResize,
        id: pkg.name
      });

      // Headline/dek/source/credit/footnote are injected into index.html from
      // src/data/meta.json at build & dev-serve time (see injectMeta in
      // vite.config.js), so there's nothing to do here.

      if (containerElement) {
        const containerWidth = containerElement.clientWidth;
        if (containerWidth && containerWidth !== width) {
          width = containerWidth;
        }
      }

      return () => {
        if (pymChild) {
          pymChild.remove();
        }
      };
    });
  </script>

  <!-- Height is bound here so Pym.js can keep the iframe sized correctly -->
  <div bind:this={containerElement} bind:clientHeight={height} class="app-container">
    <Graphic {width} {data} />
  </div>

  <style>
    .app-container {
      width: 100%;
    }
  </style>
